import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-menu-superior-template',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './menu-superior-template.component.html',
  styleUrl: './menu-superior-template.component.css'
})
export class MenuSuperiorTemplateComponent implements OnChanges {

  @Input() opcaoSelecionada = 'MARKETING';
  @Input() bloqueioTotal = false;
  @Output() opcaoSelecionadaEnvio = new EventEmitter<string>();


  ngOnChanges(): void {
    this.opcaoSelecionadaEnvio.emit(this.opcaoSelecionada);
  }

  enviarOpcaoSelecioanda(opcao: string) {
    this.opcaoSelecionada = opcao;
    this.opcaoSelecionadaEnvio.emit(opcao);
  }

}
